const tokenKey: string = "supplier-portal-access-token";

export { tokenKey };
